import { fetchEmailContent, EmailContent } from './fetchEmailContent';

export type OnContentFetchError = (contactId: string, error: unknown) => void;

// Fetches each contact's content in bounded batches - a burst of contact IDs won't fire more than
// batchSize concurrent requests at once - and tolerates individual failures without dropping the batch.
export const fetchEmailContentBatch = async (
  contactIds: string[],
  batchSize: number,
  onFetchError?: OnContentFetchError
): Promise<Map<string, EmailContent>> => {
  const contentByContactId = new Map<string, EmailContent>();

  for (let i = 0; i < contactIds.length; i += batchSize) {
    const batch = contactIds.slice(i, i + batchSize);
    const results = await Promise.allSettled(batch.map(contactId => fetchEmailContent(contactId)));

    results.forEach((result, index) => {
      const contactId = batch[index];
      if (result.status === 'fulfilled') {
        contentByContactId.set(contactId, result.value);
      } else {
        onFetchError?.(contactId, result.reason);
      }
    });
  }

  return contentByContactId;
};
